module.exports = __webpack_public_path__ + "images/marketing/bitium-integration.png";